import React, { useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { AppBarMes, Loading, CardFaturamentoInexistente, CardErro, Header, Body } from '../../presentations';
import { obterListagemDetalhamentoFaturamento, obterDetalhamentoFaturamento } from '../../redux/actions/FaturamentoAction';
import FaturamentoService from '../../services/FaturamentoService';
import LogService from '../../services/LogService';
import { converterBase64ToArrayBuffer } from '../../utils';
import { PaginaEnum, MenuEnum } from '../../enums';
import SnackbarContext from '../../providers/snackbar/SnackbarContext';

function ListagemDetalhamentoFaturamentoPage(
    {
        location,

        obterListagemDetalhamentoFaturamento,
        obterDetalhamentoFaturamento,

        listagem_detalhamento_faturamento_loading,
        listagem_detalhamento_faturamento,
        listagem_detalhamento_faturamento_erro,

        detalhamento_faturamento_loading
    }
) {
    const mensagem = useContext(SnackbarContext);

    useEffect(() => {
        LogService.registrarAcesso(PaginaEnum.FATURAMENTO, PaginaEnum.properties[PaginaEnum.FATURAMENTO].acesso);
    }, []);

    useEffect(() => {
        listagem_detalhamento_faturamento == null && obterListagemDetalhamentoFaturamento();
    }, [listagem_detalhamento_faturamento, obterListagemDetalhamentoFaturamento]);

    const handleObterDetalheFaturamento = (ano, mes) => {
        obterDetalhamentoFaturamento(ano, mes);
    }

    const handleCopiarCodigoBarras = () => {
        LogService.registrarAcesso(PaginaEnum.FATURAMENTO, PaginaEnum.properties[PaginaEnum.FATURAMENTO].copiaCodigoBarras);
        mensagem.show('success', 'Código copiado com sucesso.')
    }

    const handleBaixarFatura = (chave) => {
        FaturamentoService.baixarFatura(chave)
            .then((response) => {
                const { nomeArquivo, contentData } = response.data;
                const byteArray = converterBase64ToArrayBuffer(contentData);
                const url = window.URL.createObjectURL(new Blob([byteArray]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', nomeArquivo);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                LogService.registrarAcesso(PaginaEnum.FATURAMENTO, PaginaEnum.properties[PaginaEnum.FATURAMENTO].download);
            })
            .catch((erro) => {
                console.log(erro);
            });
    }

    const obterIndex = () => {
        const { state } = location;

        if (state) {
            let index = listagem_detalhamento_faturamento.findIndex(x => x.ano === state.ano && x.mes === state.mes);
            return index;
        }

        return listagem_detalhamento_faturamento.length - 1;
    }

    return (
        <>
            <Header titulo='Faturas'
                link={MenuEnum.properties[MenuEnum.HOME].path} />
            <Body>
                {
                    (() => {
                        if (listagem_detalhamento_faturamento_loading === null ||
                            listagem_detalhamento_faturamento_loading === true)
                            return <Loading />

                        if (listagem_detalhamento_faturamento_erro !== null)
                            return <CardErro />

                        if (listagem_detalhamento_faturamento.length === 0)
                            return <CardFaturamentoInexistente />

                        return <AppBarMes listagem_detalhamento_faturamento={listagem_detalhamento_faturamento}
                            handleObterDetalheFaturamento={handleObterDetalheFaturamento}
                            handleBaixarFatura={handleBaixarFatura}
                            handleCopiarCodigoBarras={handleCopiarCodigoBarras}
                            detalhamento_faturamento_loading={detalhamento_faturamento_loading}
                            index={obterIndex()} />
                    })()
                }
            </Body>
        </>
    )
}

const mapStateToProps = (state) => ({
    listagem_detalhamento_faturamento_loading: state.faturamento.listagem_detalhamento_faturamento_loading,
    listagem_detalhamento_faturamento: state.faturamento.listagem_detalhamento_faturamento,
    listagem_detalhamento_faturamento_erro: state.faturamento.listagem_detalhamento_faturamento_erro,

    detalhamento_faturamento_loading: state.faturamento.detalhamento_faturamento_loading,
    detalhamento_faturamento_erro: state.faturamento.detalhamento_faturamento_erro
});

const mapDispatchToProps = {
    obterListagemDetalhamentoFaturamento,
    obterDetalhamentoFaturamento
};

export default connect(mapStateToProps, mapDispatchToProps)(ListagemDetalhamentoFaturamentoPage);